//usei o centroApoio como base

import { apiSlice } from '../../../../app/apiSlice';
import configSiteUrls from '../../configs/configSiteUrls';
import { CentroApoio, CentroApoioDTO, CentroApoioList, CentroApoioLogin, CentroApoioLoginResponse, CentroApoioRespostaDTO } from './types/CentroApoio';

const endpointPublicUrl = configSiteUrls.SITE_CENTRO_APOIO_PUBLIC_EP;
const endpointtUrl = configSiteUrls.SITE_CENTRO_APOIO_EP;


function addCentroApoio(obj: CentroApoioDTO) {
  return {
    url: `${endpointPublicUrl}/create`,
    method: 'POST',
    body: obj
  };
}

function addCentroApoioResposta(obj: CentroApoioRespostaDTO) {
  return {
    url: `${endpointtUrl}/create`,
    method: 'POST',
    body: obj
  };
}

function getCentroApoioByLogin(body: CentroApoioLogin) {
  if (!body.login || !body.senha) {
    return {
      url: '',      // URL vazia
      method: 'GET' // método inofensivo
    };
  }
  return {
    url: `${endpointPublicUrl}/login`,
    method: 'POST',
    body: body
  };
}









function getCentroApoios({ search }: { search: string }) {
  return {
    url: `${endpointtUrl}/filter?search=${search}`,
    method: 'GET'
  };
}


function deleteCentroApoio({ id }: { id: string }) {
  return {
    url: `${endpointtUrl}/${id}`,
    method: 'DELETE'
  };
}
function getCentroApoio(id: string) {
  if (!id) {
    return {
      url: '',
      method: ''
    };
  }

  return {
    url: `${endpointtUrl}/${id}`,
    method: 'GET'
  };
}



export const centroApoioApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getCentroApoios: query<CentroApoioList[], { search: string }>({
      //query: (id) => `${endpointPublicUrl}/ciencia/${id}`,
      query: getCentroApoios,
      providesTags: ['CentroApoio']
    }),

    getCentroApoio: query<CentroApoio, string>({
      //query: (id) => `${endpointPublicUrl}/ciencia/${id}`,
      query: getCentroApoio,
      providesTags: ['CentroApoio']
    }),
    getCentroApoioByLogin: mutation<CentroApoio, CentroApoioLogin>({
      query: getCentroApoioByLogin,
      invalidatesTags: ['CentroApoio']

    }),

    addCentroApoio: mutation<CentroApoioLoginResponse, CentroApoioDTO>({
      query: addCentroApoio,
      invalidatesTags: ['CentroApoio']
    }),
    addCentroApoioResposta: mutation<CentroApoioLoginResponse, CentroApoioRespostaDTO>({
      query: addCentroApoioResposta,
      invalidatesTags: ['CentroApoio']
    }),
    deleteCentroApoio: mutation<void, { id: string }>({
      query: deleteCentroApoio,
      invalidatesTags: ['CentroApoio']
    })
  })
});
export const { useGetCentroApoiosQuery, useGetCentroApoioQuery, useAddCentroApoioMutation, useDeleteCentroApoioMutation,useGetCentroApoioByLoginMutation, useAddCentroApoioRespostaMutation } = centroApoioApiSlice;
